<div class="min-h-screen grid grid-cols-1 lg:grid-cols-2">

    <!-- Left Image Section -->
    <div class="hidden lg:flex flex-col items-start bg-cover bg-top text-black p-10"
        style="background-image: url('assets/img/signup.png');">
        <h1 class="text-3xl font-bold leading-tight text-center">
            Discover Bengaluru’s Finest Homes,<br>
            Curated Exclusively for You.
        </h1>
    </div>

    <!-- Right Form Section -->
    <div class="flex flex-col justify-center items-center bg-[#faf7f5] p-10">

        <!-- Logo -->
        <a routerLink="/" class="auth-logo-link" aria-label="CircledPlus home">
<img src="/cir-home/images/circledplus-logo.svg" alt="CircledPlus" class="auth-logo" width="156" height="40" />
</a>

        <!-- Icon -->
        <div class="w-16 h-16 mx-auto mb-4 rounded-full bg-emerald-50 flex items-center justify-center">
            <svg class="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
        </div> 

        <!-- Heading -->
        <h2 class="text-2xl font-bold text-gray-900 mb-2">
        Registration Received 
        </h2>

        <p class="text-gray-600 mb-6">
        Thank you for joining <span class="font-semibold text-gray-900">Circled Plus</span>.
        </p>
        <p class="text-gray-600 mb-6">Your profile is currently under review.</p>

        <!-- Message box -->
        <div class="bg-white border max-w-sm text-center border-gray-100 rounded-xl p-4 text-sm text-gray-600 leading-relaxed">
            We screen all accounts to maintain a private and curated experience. You’ll be notified once your access is approved.
        </div>

        <!-- CTA -->
        <a routerLink="/" 
        class="inline-block mt-8 bg-black text-white px-6 cursor-pointer py-3 rounded-full font-semibold hover:bg-gray-800 transition">
        Back to Home
        </a>

    </div>
</div>